<qpx-confirmation-dialog
    [title]="data().title ?? ''"
    [status]="data().status ?? 'default'"
    [confirmButton]="data().confirmButton ?? 'OK'"
    [cancelButton]="data().cancelButton ?? false"
    (confirm)="onConfirm()"
    (dismiss)="onCancel()"
>
    @if (data().contentTpl) {
        <ng-container
            [ngTemplateOutlet]="data().contentTpl"
            [ngTemplateOutletContext]="data().contentTplContext"
        />
    } @else if (data().contentHtml) {
        <div
            class="prose prose-sm prose-qpx max-w-none break-words prose-h1:text-heading-lg prose-h2:text-modal-title prose-h3:text-heading-sm"
            [innerHTML]="data().contentHtml"
        ></div>
    } @else {
        @if (data().text1) {
            <p class="whitespace-pre-line">{{ data().text1 }}</p>
        }
        @if (data().text2) {
            <p class="whitespace-pre-line">{{ data().text2 }}</p>
        }
        @if (data().text3) {
            <p class="whitespace-pre-line">{{ data().text3 }}</p>
        }
    }
</qpx-confirmation-dialog>
